import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Fragment } from "@msuite/ui/utils";
import type { GetWarehouseLocationsQuerySchema } from "@msuite/utils/schemas";
import { Can } from "@/components/citadel/can";
import { useWarehouseLocations } from "@/hooks/use-warehouse-locations";
import { SelectWarehouseLocationsModal } from "@/modals/stock/select-warehouse-locations-modal";

interface WarehouseLocationsMenuProps {
	query: GetWarehouseLocationsQuerySchema;
	onComplete?: () => Promise<void>;
}

export function WarehouseLocationsMenu({ query, onComplete }: WarehouseLocationsMenuProps) {
	const { t } = useTranslation();
	const disclosure = useDisclosure();
	const { warehouseLocations: currentLocations, refetch } = useWarehouseLocations(query);
	const currentLocationIds = currentLocations.map((loc) => loc.id);

	async function handleOnComplete() {
		await refetch();
		await onComplete?.();
	}

	return (
		<Fragment>
			<Can
				action="update"
				subject="Stock"
			>
				<Button
					variant="primary"
					icon={<Icon name="MousePointer2" />}
					onClick={disclosure.onOpen}
				>
					{t("stock.select_warehouse_locations")}
				</Button>
			</Can>
			{disclosure.isOpen && (
				<SelectWarehouseLocationsModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					initialWarehouseLocationIds={currentLocationIds}
					query={query}
					onComplete={handleOnComplete}
				/>
			)}
		</Fragment>
	);
}
